export default {"src":"/_next/static/media/notes.26f0ddd5.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};